<template>
  <form :id="'frm-'+id"
        class="px-3"
        method="post"
        onsubmit="return false">
    <div :id="id"
         :data-id="name"
         :aria-labelledby="id+'-title'"
         :data-backdrop="'static'"
         :data-keyboard="'false'"
         aria-hidden="true"
         class="modal fade"
         role="dialog"
         tabindex="-1">
      
      <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header mb-2">
            <h5 :id="id+'-title'" class="modal-title">{{ title }}</h5>
          </div>
          <div class="modal-body">
            <div class="container">
              <p>
                {{ message }}
              </p>
            </div>
          </div>

          <div class="modal-footer flex px-2 shadow-none modal-body-scrolled">
            <button class="btn btn-secondary"
                    data-dismiss="modal"
                    type="button">Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>  
  export default {
    name: 'MessageModal',
    components: {},
    props: {
      id: {
        default: 'message-modal',
      },
      name: {
        default: 'message-modal',
      },
      title: {
        type: String,
        default: null,
      },
      message: {
        type: String,
        default: null,
      },
    },
  }
</script>
